import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { AuthStorageService, BaseSiteService, UserIdService } from '@spartacus/core';
import { UserProfileFacade } from '@spartacus/user/profile/root';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ASM_ENABLED_LOCAL_STORAGE_KEY } from 'src/app/spartacus/features/asm/asm-constant';
import { environment } from 'src/environments/environment';
import { StorageService } from '../storage/storage.service';

export interface ChangePayload {
  oldPassword: string;
  newPassword: string;
}

@Injectable({
  providedIn: 'root',
})
export class PasswordService {
  baseSite$: Observable<string> = this.baseService.getActive();
  occUrl = this.meta.getTag('name=occ-backend-base-url');
  userCurrent$: Observable<string> = this.auth.getUserId();
  asmEnabled = this.storageService.getLocalStorageItem(ASM_ENABLED_LOCAL_STORAGE_KEY);
  baseSiteId: any;
  headers = new HttpHeaders().set('Content-Type', 'application/json');

  constructor(
    protected meta: Meta,
    protected http: HttpClient,
    protected baseService: BaseSiteService,
    protected userService: UserProfileFacade,
    protected auth: UserIdService,
    protected authStorageService: AuthStorageService,
    private storageService: StorageService
  ) {
    this.baseSite$.pipe(take(1)).subscribe((data) => {
      this.baseSiteId = data;
    });
  }

  get userId(): Observable<string> {
    let userId: any;
    this.auth.getUserId().subscribe((data: any) => {
      userId = data;
    });
    return userId;
  }

  get userCurrent(): string {
    let userCurrent: string;
    this.userCurrent$.pipe(take(1)).subscribe((userId) => (userCurrent = userId));
    return userCurrent;
  }
  changeUserPassword(payload: ChangePayload) {
    const asmQuery = this.asmEnabled ? `?asmUser=${this.userCurrent}` : '';
    const body = {
      oldPassword: payload.oldPassword,
      newPassword: payload.newPassword,
    };

    return this.http
      .post(
        `${this.occUrl.content}${environment.prefix}${this.baseSiteId}/users/${this.userId}/password`,
        JSON.stringify(body),
        {
          headers: this.headers,
        }
      )
      .pipe(map((data) => data));
  }
}
